// Entidades legales del grupo Punto Hispano (registro suizo UID)
// Si un servicio no tiene empresa propia, se usa la Gestoría por defecto.

export type CompanyKey = "gestoria" | "holding" | "immobilien" | "seguros";

export interface CompanyEntity {
  key: CompanyKey;
  name: string;
  uid: string; // UID suizo (CHE-...)
}

export const COMPANY_ENTITIES: Record<CompanyKey, CompanyEntity> = {
  gestoria: {
    key: "gestoria",
    name: "Punto Hispano Gestoria GmbH",
    uid: "CHE-374.730.280",
  },
  holding: {
    key: "holding",
    name: "Punto Hispano Holding GmbH",
    uid: "CHE-340.218.268",
  },
  immobilien: {
    key: "immobilien",
    name: "Punto Hispano Immobilien GmbH",
    uid: "CHE-240.749.559",
  },
  seguros: {
    key: "seguros",
    name: "Punto Hispano Seguros y Pensiones GmbH",
    uid: "CHE-241.821.751",
  },
};

// Mapea cada área de servicio a la entidad legal responsable.
// Servicios sin empresa propia caen en la Gestoría por defecto.
export const SERVICE_COMPANY_MAP: Record<string, CompanyKey> = {
  gestoria: "gestoria",
  legal: "gestoria",
  idiomas: "gestoria",
  digitales: "gestoria",
  emprende: "gestoria",
  contacto: "gestoria",
  vivienda: "immobilien",
  alquileres: "immobilien",
  inmobiliaria: "immobilien",
  immobilien: "immobilien",
  seguros: "seguros",
  pensiones: "seguros",
};

export const getCompanyForService = (serviceKey?: string): CompanyEntity => {
  if (!serviceKey) return COMPANY_ENTITIES.gestoria;
  const key = SERVICE_COMPANY_MAP[serviceKey.toLowerCase()] ?? "gestoria";
  return COMPANY_ENTITIES[key];
};

export const ALL_COMPANIES: CompanyEntity[] = [
  COMPANY_ENTITIES.holding,
  COMPANY_ENTITIES.gestoria,
  COMPANY_ENTITIES.immobilien,
  COMPANY_ENTITIES.seguros,
];
